import { supabaseAuthProvider } from 'ra-supabase'
import { supabaseClient } from './'

const IDENTITY_SELECT = `
  id,
  first_name,
  last_name,
  full_name,
  email,
  phone,
  user_auth_id,
  role: role_id (id, name, reference, grade),
  center: center_id (id, name, center_type_id),
  tours,
  faculte_id,
  mineure_id,
  grand_admis,
  has_licence,
  has_car,
  faculte:faculte_id(id, name),
  mineure:mineure_id(id, name)
`

// Fallback select for backwards compat during migration (fac_id → faculte_id)
const IDENTITY_SELECT_LEGACY = `
  id,
  first_name,
  last_name,
  full_name,
  email,
  phone,
  user_auth_id,
  role: role_id (id, name, reference, grade),
  center: center_id (id, name, center_type_id),
  tours
`

const baseAuthProvider = supabaseAuthProvider(supabaseClient, {
  getIdentity: async profile => {
    // Try new column names first, fall back to legacy if migration not yet applied
    let { data, error } = await supabaseClient
      .from('profiles')
      .select(IDENTITY_SELECT)
      .match({ user_auth_id: profile.id })
      .single()

    if ( error ) {
      const legacy = await supabaseClient
        .from('profiles')
        .select(IDENTITY_SELECT_LEGACY)
        .match({ user_auth_id: profile.id })
        .single()

      if ( legacy.data && !legacy.error ) {
        data = {
          ...legacy.data,
          faculte_id: legacy.data.fac_id,
          faculte: legacy.data.fac,
        }
        error = null
      }
    }

    if ( !data || error ) {
      throw new Error()
    }

    return {
      ...data,
      fullName: data.full_name,
    }
  }
})

const authProvider = baseAuthProvider
export default authProvider